import useFeatureFlag from 'src/hooks/useFeatureFlag';
import useIsInterviewHop from 'src/interviews/hooks/useIsInterviewHop';
import { Wrapper } from '../RichEndings';
import useRichEndingContext from '../RichEndings/useRichEndingContext';
import EmailTranscriptCard from './EmailTranscriptCard';

import type { MiniInterviewType } from 'src/packages/polaris/types';

type Props = {
  interviewType: MiniInterviewType;
};
const EmailTranscriptCardWrapper = (props: Props) => {
  const { interviewType } = props;

  const isInterviewHop = useIsInterviewHop();
  const { relatedReadings, treatmentSuppliers } = useRichEndingContext();

  const emailCollectionExperiment =
    useFeatureFlag({
      flagName: 'growth-public-site-rich-ending-email-collection',
      defaultValue: {
        enabled: true,
        description: "Don't lose your results! Get a copy of your visit sent to your email",
        cta: 'Submit',
      },
    }) || {};

  const isEmailCollectionEnabled =
    emailCollectionExperiment?.enabled &&
    ['dxoc', 'symptoms'].includes(interviewType) &&
    !isInterviewHop;

  if (!isEmailCollectionEnabled) {
    return null;
  }

  return (
    <Wrapper component="EmailTranscriptCard">
      <EmailTranscriptCard
        descriptionText={emailCollectionExperiment?.description}
        interviewType={interviewType}
        result={{
          relatedReadings,
          treatmentSuppliers,
        }}
        submitText={emailCollectionExperiment?.cta}
      />
    </Wrapper>
  );
};

export default EmailTranscriptCardWrapper;
